import { margin, marginBottom, media, padding, paddingBottom } from "../../styles";
import styled from "styled-components";
export const List = styled.ul`
  list-style: none;
  ${padding.zero}
  ${margin.zero}

  > li {
    &:not(:last-child) {
      ${marginBottom.m}
      @media ${media.mobile} {
        ${paddingBottom.m}
        border-bottom: 1px solid ${({
  theme
}) => theme.brand.cssVars["--d-border"]}
      }
    }
  }
`;
export default List;
export { ListItem } from "./ListItem/ListItem";